import { useState } from "react";
import { CompanyLogo } from "@/components";
import styles from "./styles.scss";

export const ImageLoader = ({ src }: { src: string }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {loaded ? null : <CompanyLogo className={styles.loader} />}
      <img
        style={loaded ? {} : { display: "none" }}
        src={src}
        onLoad={() => setLoaded(true)}
        alt=""
      />
    </>
  );
};
